var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 703,
    viewBox: "0 0 1040 703",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.66 367.116C1039.61 368.439 1039.55 369.848 1039.51 371.385C1039.7 368.034 1039.68 366.475 1039.66 367.116Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.375 455.296C518.577 452.265 517.888 448.786 517.306 444.965C521.681 477.944 530.346 508.468 547.051 543.881C547.051 543.881 561.169 579.016 598.243 617.288C619.409 639.21 648.12 662.136 685.948 680.109C693.643 683.78 701.704 687.217 710.175 690.419C722.267 695.008 744.296 698.189 774.429 697.164C777.489 697.057 780.636 696.908 783.87 696.716C786.068 696.588 788.288 696.438 790.551 696.267C791.78 696.054 792.987 695.819 794.194 695.584C798.462 694.752 802.665 693.834 806.803 692.81C808.571 692.383 810.252 691.956 811.847 691.55C813.464 691.123 815.016 690.718 816.481 690.312C822.646 688.583 828.66 686.683 834.522 684.591C829.673 686.022 810.64 691.123 783.87 692.447C780.83 692.596 777.662 692.703 774.429 692.745C748.994 693.087 717.978 689.714 685.948 677.291C656.375 665.871 625.919 646.703 598.243 615.645C566.493 579.998 538.364 528.661 519.375 455.296V455.296Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.932 0V355.021C512.932 376.388 513.234 395.557 514.312 413.509C512.587 380.444 513.751 344.647 513.751 344.647V0.576333C513.6 0.469605 513.492 0.384222 513.385 0.320185C513.104 0.106729 512.954 0 512.932 0Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.669 416.909V616.961C785.772 617.708 788.919 618.327 792.109 618.861C803.231 620.739 814.763 621.486 825.67 621.614C834.873 621.721 844.034 621.145 853.087 619.907V411.039L792.109 416.119L782.669 416.909V416.909Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.823 397.466C630.483 472.858 648.313 531.325 686.098 573.163V237.459L625.594 257.78C625.594 257.78 625.153 309.197 625.594 342.138C625.884 363.749 625.594 372.157 626.823 397.466Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.086 411V619.889C871.494 617.37 889.47 612.098 906.434 604.157V450.554L853.086 411V411Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.098 237.426V573.151C704.764 593.813 728.948 610.249 760.331 622.203C764.858 623.932 769.643 625.341 774.579 626.494C777.683 627.241 780.829 627.86 784.02 628.393V310.706L686.098 237.426Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.311 413.518C514.354 413.838 514.289 424.779 514.311 425.099C514.957 435.452 515.927 434.778 517.242 444.491C517.242 444.64 517.264 444.811 517.307 444.96C517.889 448.781 518.578 452.261 519.376 455.292C538.365 528.657 566.494 579.993 598.244 615.64C625.92 646.698 656.376 665.867 685.949 677.287C717.978 689.71 748.995 693.083 774.43 692.741C777.663 692.698 780.831 692.592 783.87 692.442C810.641 691.119 829.674 686.017 834.523 684.587C834.545 684.587 834.588 684.566 834.61 684.566C838.08 683.349 841.485 682.068 844.848 680.723C864.333 672.996 882.116 663.476 898.195 652.867C943.265 623.154 975.037 584.988 993.035 554.272C1033.76 513.61 1038.04 588.211 1039.44 554.272C1037.87 579.63 1026.51 502.978 949.258 577.496C933.911 592.31 916.646 604.114 898.195 612.737C881.232 620.678 863.255 625.95 844.848 628.469C835.795 629.707 826.634 630.284 817.431 630.177C806.524 630.049 794.992 629.302 783.87 627.423C780.68 626.89 777.533 626.271 774.43 625.523C769.494 624.371 764.708 622.962 760.182 621.233C728.799 609.279 704.615 592.843 685.949 572.181C648.164 530.343 633.931 482.127 626.674 396.484C625.898 387.327 625.445 341.156 625.445 341.156V83.0443C625.445 83.0443 523.902 7.88616 513.75 0.585938V344.657C513.75 344.657 512.586 380.454 514.311 413.518Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.001 79.7261V402.366C426.001 405.824 426.065 409.389 426.195 413.018C430.549 539.299 510.3 628.011 598.242 671.343C624.862 684.449 652.214 693.393 678.446 697.982C680.968 698.431 683.468 698.815 685.947 699.178C718.71 703.981 749.447 702.444 774.428 698.922C777.683 698.473 780.83 697.982 783.869 697.47C787.469 696.872 790.917 696.232 794.194 695.57C798.72 694.653 802.923 693.713 806.803 692.795C808.57 692.368 810.252 691.942 811.847 691.536C813.463 691.109 815.015 690.704 816.481 690.298C827.711 687.224 834.565 684.663 835.6 684.257C835.427 684.3 835.104 684.407 834.608 684.556C834.587 684.556 834.543 684.577 834.522 684.577C829.672 686.008 810.64 691.109 783.869 692.433C780.83 692.582 777.661 692.689 774.428 692.731C748.994 693.073 717.977 689.7 685.947 677.277C656.374 665.857 625.918 646.689 598.242 615.631C566.492 579.983 537.76 530.994 519.374 455.282C518.577 452.251 517.887 448.772 517.305 444.951C517.262 444.801 517.24 444.631 517.24 444.481C515.861 435.708 514.956 425.27 514.374 414.469C514.374 414.149 514.309 413.508 514.309 413.508L513.749 344.647V0C513.749 0 513.619 0.106729 513.382 0.320185C513.274 0.426914 513.124 0.554988 512.93 0.725753C504.049 8.66635 426.001 79.47 426.001 79.7261Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00947128 395.061C0.0394217 395.98 0.084347 396.959 0.114297 398.027C-0.0204797 395.699 -0.00550395 394.616 0.00947128 395.061Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.482 456.324C362.036 454.218 362.515 451.801 362.92 449.146C359.88 472.059 353.86 493.266 342.254 517.87C342.254 517.87 332.445 542.28 306.688 568.871C291.982 584.101 272.035 600.029 245.754 612.516C240.407 615.067 234.807 617.454 228.921 619.679C220.52 622.867 205.216 625.077 184.28 624.365C182.154 624.291 179.967 624.187 177.721 624.054C176.194 623.965 174.651 623.861 173.079 623.742C172.225 623.594 171.387 623.431 170.548 623.268C167.583 622.689 164.663 622.052 161.787 621.34C160.559 621.043 159.391 620.747 158.283 620.465C157.16 620.168 156.082 619.887 155.064 619.605C150.781 618.404 146.603 617.084 142.529 615.63C145.899 616.624 159.122 620.168 177.721 621.088C179.833 621.192 182.034 621.266 184.28 621.295C201.951 621.533 223.5 619.189 245.754 610.558C266.3 602.624 287.46 589.307 306.688 567.729C328.746 542.962 348.289 507.296 361.482 456.324V456.324Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.958 140V386.656C365.958 401.501 365.749 414.818 365 427.291C366.198 404.319 365.389 379.448 365.389 379.448V140.4C365.494 140.326 365.569 140.267 365.644 140.222C365.839 140.074 365.943 140 365.958 140Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.187 429.654V568.643C182.03 569.162 179.844 569.592 177.628 569.963C169.9 571.268 161.889 571.787 154.311 571.876C147.917 571.95 141.552 571.55 135.263 570.69V425.576L177.628 429.106L184.187 429.654V429.654Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.841 409.517C284.298 461.896 271.911 502.517 245.659 531.584V298.35L287.695 312.468C287.695 312.468 288.002 348.191 287.695 371.077C287.493 386.091 287.695 391.933 286.841 409.517Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.262 425.551V570.679C122.473 568.929 109.984 565.266 98.1982 559.749V453.031L135.262 425.551V425.551Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.658 298.328V531.577C232.69 545.933 215.888 557.352 194.084 565.657C190.939 566.858 187.614 567.837 184.185 568.638C182.029 569.157 179.842 569.587 177.626 569.958V349.24L245.658 298.328Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_522_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365 427.296C364.97 427.519 365.015 435.12 365 435.342C364.55 442.535 363.877 442.067 362.963 448.815C362.963 448.919 362.948 449.037 362.918 449.141C362.514 451.796 362.035 454.213 361.481 456.319C348.287 507.29 328.745 542.957 306.686 567.723C287.458 589.301 266.298 602.619 245.752 610.553C223.499 619.184 201.949 621.527 184.279 621.29C182.032 621.26 179.831 621.186 177.719 621.082C159.12 620.163 145.897 616.619 142.528 615.625C142.513 615.625 142.483 615.61 142.468 615.61C140.057 614.765 137.691 613.875 135.355 612.941C121.817 607.572 109.462 600.958 98.2908 593.587C66.9776 572.944 44.9041 546.427 32.3998 525.087C4.92026 478.223 15.4523 507.091 14.4789 483.511C15.5721 501.129 9.14328 489.45 62.8145 541.222C73.4769 551.514 85.472 559.715 98.2908 565.706C110.076 571.223 122.566 574.886 135.355 576.636C141.644 577.496 148.009 577.897 154.403 577.823C161.98 577.734 169.992 577.215 177.719 575.91C179.936 575.539 182.122 575.109 184.279 574.59C187.708 573.789 191.032 572.81 194.177 571.609C215.981 563.304 232.783 551.885 245.752 537.529C272.004 508.462 281.892 474.963 286.934 415.462C287.473 409.1 287.787 377.022 287.787 377.022V197.695C287.787 197.695 358.336 145.478 365.389 140.406V379.454C365.389 379.454 366.198 404.324 365 427.296Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.355 195.391V419.549C426.355 421.952 426.31 424.428 426.22 426.949C423.195 514.685 367.786 576.319 306.688 606.424C288.193 615.53 269.19 621.744 250.965 624.933C249.213 625.244 247.475 625.511 245.753 625.763C222.991 629.1 201.636 628.032 184.28 625.585C182.019 625.274 179.832 624.932 177.721 624.577C175.22 624.161 172.824 623.716 170.548 623.257C167.403 622.619 164.483 621.966 161.787 621.329C160.559 621.032 159.391 620.736 158.283 620.454C157.16 620.157 156.082 619.875 155.063 619.594C147.261 617.458 142.499 615.678 141.78 615.397C141.9 615.426 142.125 615.5 142.469 615.604C142.484 615.604 142.514 615.619 142.529 615.619C145.898 616.613 159.122 620.157 177.721 621.077C179.832 621.18 182.034 621.255 184.28 621.284C201.951 621.522 223.5 619.178 245.753 610.547C266.299 602.613 287.459 589.296 306.688 567.718C328.746 542.951 348.708 508.915 361.482 456.313C362.036 454.207 362.515 451.79 362.92 449.135C362.95 449.032 362.964 448.913 362.964 448.809C363.923 442.714 364.552 435.462 364.956 427.958C364.956 427.735 365.001 427.29 365.001 427.29L365.39 379.448V140C365.39 140 365.48 140.074 365.645 140.222C365.72 140.297 365.825 140.386 365.96 140.504C372.129 146.021 426.355 195.213 426.355 195.391Z",
    fill: "#EBEFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_522_219",
    x: 853.086,
    y: 411,
    width: 58.3477,
    height: 214.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_522_219",
    x: 686.098,
    y: 237.426,
    width: 102.922,
    height: 396.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_522_219",
    x: 513.366,
    y: 0.585938,
    width: 531.075,
    height: 698.178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_522_219",
    x: 98.1982,
    y: 425.551,
    width: 42.0635,
    height: 151.129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_522_219",
    x: 177.626,
    y: 298.328,
    width: 73.0322,
    height: 277.629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_522_219",
    x: 13.2852,
    y: 140.406,
    width: 357.371,
    height: 486.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_522_219",
    result: "effect2_innerShadow_522_219"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBuildings);
export default __webpack_public_path__ + "static/media/about_buildings.24b7e50f240970a8b298a55a7524c875.svg";
export { ForwardRef as ReactComponent };